<template>
  <div class="configuration__content">
    <b-container
      fluid
      class="pt-2"
      v-if="!!isSensorComponentized"
    >
      <group-componentized-module
        :options="sensorInformation"
        :selected-information="selectedInformation"
        @on-change-selected-information="onChangeSelectedInformationHandler"
      />
    </b-container>
    <s-empty-list
      :loading="loading"
      v-show="!contacts.length"
    />
    <contact-list-item
      class="mb-3"
      :contact="contacts"
      :loading="loading"
      @edit-contact="editContact"
      @delete-contact="confirmExclusion"
    />
    <contact-dm2-modal
      :contact-id="editContactId"
      :active="contactModalOpen"
      :sensor-id="selectedAssetModuleId"
      :is-loading="loading"
      :used-names="usedNames"
      @close="closeContactModal"
      @submit="submitContact"
    />
  </div>
</template>
<script>
import ContactServiceDM2 from '@/domain/services/installation/supervision/sensors/contactDm2';
import eventBus from '@/services/globalEventBus';
import event from '@/domain/events/engineeringModulesHeader';
import ContactListItem from '@/domain/components/installation/supervision/sensors/configurationDM2/ContactListItem';
import ContactDm2Modal from '@/domain/components/installation/supervision/sensors/configurationDM2/ContactDM2Modal';
import GroupComponentizedModule from '@/domain/components/installation/supervision/sensors/GroupComponentizedModule';
import { ModuleCategorys } from 'sigma-mappings';

export default {
  components: {
    ContactListItem,
    ContactDm2Modal,
    GroupComponentizedModule,
  },
  props: {
    category: String,
    isSensorComponentized: {
      type: Boolean,
      default: false,
    },
    selectedInformation: {
      type: Object,
      default: () => ({}),
    },
    sensorInformation: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    contacts: [],
    contactModalOpen: false,
    editContactId: null,
    loading: false,
    usedNames: [],
  }),
  methods: {
    refreshDataEvent({ wait }) {
      wait(this.loadContacts());
    },
    loadContacts() {
      this.loading = true;
      this.contacts = [];
      return ContactServiceDM2.getContactsBySensor(this.selectedAssetModuleId)
        .then((contacts) => {
          this.contacts = contacts;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editContact(contact) {
      this.editContactId = contact.id;
      this.usedNames = (this.contacts || [])
        .filter(x => x.id !== contact.id && !!x.description)
        .map(x => x.description.trim().toLowerCase());
      this.contactModalOpen = true;
    },
    closeContactModal() {
      this.contactModalOpen = false;
    },
    submitContact(contact) {
      this.loading = true;

      this.updateContact(contact)
        .then(() => {
          this.$pushAlert({ code: 'MS006' });
          this.loadContacts();
          this.closeContactModal();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateContact(contact) {
      return ContactServiceDM2.updateContact(contact);
    },
    confirmExclusion(contact) {
      this.$confirmMessage({ code: 'MC011' })
        .accepted(() => {
          this.deleteContact(contact.id);
        });
    },
    deleteContact(contactId) {
      ContactServiceDM2.deleteContact(contactId).then(() => {
        this.$pushAlert({ code: 'MS007' });
        this.loadContacts();
      });
    },
    onChangeSelectedInformationHandler(value) {
      this.$emit('on-change-selected-information', value);
    },
  },
  computed: {
    hasSupervisorPermission() {
      return this.$hasUserPermission('PER015');
    },
    selectedAssetModuleId() {
      const { sensorId } = this.$route.params;
      const { assetModuleId } = this.selectedInformation || {};
      return this.category === ModuleCategorys.COMPONENTIZED
        ? assetModuleId
        : sensorId;
    },
  },
  created() {
    this.loadContacts();
    eventBus.on(event.refresh, this.refreshDataEvent, this);
  },
  beforeDestroy() {
    eventBus.off(event.refresh, this.refreshDataEvent, this);
  },
};
</script>
<style lang="sass" scoped>
</style>
